// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icons-container[data-v-79bf621a]{margin:10px 20px 0;overflow:hidden}.icons-container .icon-item[data-v-79bf621a]{margin:20px;height:85px;text-align:center;width:100px;float:left;font-size:30px;color:#24292e;cursor:pointer}.icons-container span[data-v-79bf621a]{display:block;font-size:16px;margin-top:10px}.icons-container .disabled[data-v-79bf621a]{pointer-events:none}\n", ""]);
// Exports
module.exports = exports;
